import { useQuery } from '@tanstack/react-query';
import { fetchAddressHistoryByValidAddressId, fetchAddressHistoryByWorkOrderId } from "./endpoints";
import { getErrorMessage } from 'modules/CustomerProducts/helpers';
export const useAddressHistory = (isCustomerInfoRoute, workOrderId, validAddressId) => {
    const enabled = isCustomerInfoRoute
        ? !!validAddressId
        : !!workOrderId;
    const { data: addressHistory = [], isFetching, isLoading: isAddressHistoryLoading, isError, error, refetch, } = useQuery({
        queryKey: isCustomerInfoRoute
            ? ['address-history', validAddressId]
            : ['address-history', workOrderId],
        queryFn: () => isCustomerInfoRoute
            ? fetchAddressHistoryByValidAddressId(validAddressId)
            : fetchAddressHistoryByWorkOrderId(workOrderId),
        enabled,
    });
    const errorMessage = getErrorMessage(error);
    return {
        addressHistory,
        isAddressHistoryLoading,
        isFetching,
        isError,
        addressHistoryError: errorMessage,
        refetch,
    };
};
